
define('template!kitlCreateEditLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n      <div class="error-msg">  </div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      <div class="form-group" data-field-name="lotNb">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('kitl.lotNb') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="lotNb"\n                 placeholder="' +
((__t = ( _.i18n('kitl.lotNb') )) == null ? '' : __t) +
'" value="' +
((__t = ( lotNb )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n("kitl.prodDt") )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="datepicker" class="form-control date-proddt js-info-input" data-field-name="prodDt" placeholder="' +
((__t = ( prodDt )) == null ? '' : __t) +
'" value="' +
((__t = ( prodDt )) == null ? '' : __t) +
'">\n          <span class="input-group-btn">\n              <span class="caret pull-right m-t-5"></span>\n          </span>\n        </div>\n      </div>\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n("kitl.expDt") )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="datepicker" class="form-control date-expdt js-info-input" data-field-name="expDt" placeholder="' +
((__t = ( expDt )) == null ? '' : __t) +
'" value="' +
((__t = ( expDt )) == null ? '' : __t) +
'">\n          <span class="input-group-btn">\n              <span class="caret pull-right m-t-5"></span>\n          </span>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="st">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('kitl.st') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="st"\n                 placeholder="' +
((__t = ( _.i18n('kitl.st') )) == null ? '' : __t) +
'" value="' +
((__t = ( st )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel-popup">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button disabled class="btn btn-primary disabled-grey js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

